// extracted by mini-css-extract-plugin
export default {"tableCellWrapper":"CellWithInputPadding_tableCellWrapper__zq5i2"};